import React, { useEffect, useId } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import { SelectControl } from '@si-armes/dsfr-react';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
    CONTEXT_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
} from '../../../../constants/apiUrls.constants';
import { formaterOptions } from '../../../../utils/utils';

const SelectQuestionsCompteUsager = ({
    referentielQuestionsCompteUsager,
    getApi,
    name,
    label,
    texteAide,
    error,
    warning,
    valid,
    message,
    state,
    disabled,
    required,
    onChange,
    register,
}) => {
    const getQuestionsCompteUsager = () => {
        getApi(
            usagerClientReducer,
            API_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
            CONTEXT_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER,
        );
    };

    useEffect(() => {
        if (
            !referentielQuestionsCompteUsager ||
            Object.keys(referentielQuestionsCompteUsager).length === 0
        ) {
            getQuestionsCompteUsager();
        }
    }, [referentielQuestionsCompteUsager]);

    const getOptions = () => {
        if (referentielQuestionsCompteUsager) {
            return referentielQuestionsCompteUsager.map((element) => {
                return {
                    key: element.questionCompteUsager,
                    value: element.questionCompteUsager,
                    libelle: element.questionCompteUsager,
                };
            });
        }
        return [];
    };

    const selectId = useId();

    return (
        <SelectControl
            id={`simple-${selectId}`}
            name={name}
            label={label}
            hintText={texteAide}
            options={formaterOptions(getOptions())}
            disabled={disabled}
            error={error}
            warning={warning}
            state={state}
            message={message}
            valid={valid}
            required={required}
            onChange={onChange}
            {...register}
            placeholder={
                referentielQuestionsCompteUsager
                    ? '-- Choisir une option --'
                    : 'Chargement en cours...'
            }
        />
    );
};

SelectQuestionsCompteUsager.propTypes = {
    name: PropTypes.string.isRequired,
    referentielQuestionsCompteUsager: PropTypes.array,
    getApi: PropTypes.func.isRequired,
    label: PropTypes.string,
    texteAide: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    /** Fonction register de React Hook Form */
    register: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        ref: PropTypes.any.isRequired,
    }),
    onChange: PropTypes.func,
    error: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
    message: PropTypes.string,
    state: PropTypes.string,
    warning: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
    valid: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
};

SelectQuestionsCompteUsager.defaultProps = {
    label: null,
    disabled: false,
    required: false,
    texteAide: null,
    onChange: null,
};

export default connect(
    (state) => {
        const { isLoading, erreur, data } = state.referentiel.questionsCompteUsager;
        return {
            isLoading,
            erreur,
            referentielQuestionsCompteUsager: data,
        };
    },
    {
        getApi: getAPI,
    },
)(SelectQuestionsCompteUsager);
